export const ModelNameEnum = {
  // OpenAI
  GPT_4_1: 'gpt-4.1-2025-04-14',
  GPT_4_O_MINI: 'gpt-4o-mini',
  GPT_4_O: 'gpt-4o',
  GPT_O4_MINI: 'o4-mini-2025-04-16',
  GPT_O3: 'o3-2025-04-16',
  // Anthropic
  CLAUDE_4_OPUS: 'claude-opus-4-20250514',
  CLAUDE_4_SONNET: 'claude-sonnet-4-20250514',
  CLAUDE_3_7_SONNET: 'claude-3-7-sonnet-20250219',
  CLAUDE_3_5_SONNET: 'claude-3-5-sonnet-20240620',
  // Google
  GEMINI_2_5_FLASH: 'gemini-2.5-flash',
  GEMINI_2_5_PRO: 'gemini-2.5-pro',
  GEMINI_3_FLASH_PREVIEW: 'gemini-3-flash-preview',
  GEMINI_3_PRO_PREVIEW: 'gemini-3-pro-preview',
};

export const getModelLabel = (modelName) => {
  const formattedName = modelName
    .replace(/-/g, ' ')
    .replace(/\./g, '.')
    .replace(/(\d+)(\s+)(\d+)/, '$1.$3');
  return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
};

export const getModelProvider = (modelName) => {
  if (!modelName) return '';

  if (modelName.includes('claude')) {
    return 'Anthropic';
  } else if (modelName.includes('gpt') || modelName.includes('o1') || modelName.includes('o3') || modelName.includes('o4')) {
    return 'OpenAI';
  } else if (modelName.includes('gemini')) {
    return 'Google';
  }
  return '';
};

export default ModelNameEnum;
